import * as React from "react";
import { Modal } from "react-bootstrap";

export namespace BootstrapComp {
    export const CustomModal = (props: {
        visible: boolean;
        size: "sm" | "lg" | "xl" | "xxl"; // xxl needs special handling
        header?: any;
        body: any;
        footer?: JSX.Element;
        onDismiss: () => void;
    }) => {
        const dialogClassName = props.size === "xxl" ? "modal-xxl" : undefined;
        const size = props.size !== "xxl" ? props.size : undefined;
        return (
            <Modal
                className="modal-container custom-map-modal"
                dialogClassName={dialogClassName}
                show={props.visible}
                enforceFocus={false}
                size={size}
                aria-labelledby="contained-modal-title-vcenter"
                onHide={props.onDismiss}
                centered
                backdrop="static"
                keyboard={false}
                animation={true}
                scrollable={true}>
                    <Modal.Header closeButton={true}>
                        <Modal.Title>
                            {props.header}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {props.body}
                    </Modal.Body>
                    <Modal.Footer>
                        {props.footer}
                    </Modal.Footer>
            </Modal>
        );
    };
}